import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import {Trans} from "@lingui/macro";
// import { getAllStatementColumns } from '../../../containers/AppPage/Contacts/Statement/Table/getAllStatementColumns';
import { store } from '../../../redux/store';
import Moment from 'moment';
import BukkuTooltip from 'bukku/components/Tooltip';
import TransactionLink from 'bukku/components/TransactionLink';
import TransactionType from 'bukku/components/TransactionType';
import Amount from '../../../containers/AppPage/Contacts/Statement/Table/Amount';

function renderDate(text, record) {
    const label = Moment(text).format('DD/MM/YYYY');
    if (record.type === 'opening_invoice' || !record.id)
        return label;
    if (record.type === 'closing_balance')
        return <span>{text}</span>;
    return <TransactionLink
        transaction={record}
        label={<div className="ellipsis-div">{label}</div>}
    />;
}

function renderNumber(text, record) {
    const label = text || '-';
    if (record.type === 'opening_balance' || record.type === 'closing_balance')
        return null;
    if (record.type === 'opening_invoice' || !record.id)
        return label;
    return <TransactionLink
        transaction={record}
        label={<div className="ellipsis-div">{label}</div>}
    />;
}

function renderRefNo(text, record) {
    const label = text || '-';
    if (record.type === 'opening_balance' || record.type === 'closing_balance')
        return null;
    return label;
}

function renderType(text, record) {
    if (record.type === 'opening_balance' || record.type === 'closing_balance')
        return null;

    if (text) {
        return (
            <div className="ellipsis-div" style={{ maxWidth: 270 }}>
                <TransactionType record={record} />
            </div>
        );
    }
    return '-';
}

function renderDescription(text, record) {
    if (record.type === 'opening_balance' || record.type === 'closing_balance')
        return null;

    if (text) {
        return (
            <div className="ellipsis-div" style={{ maxWidth: 270 }}>
                <BukkuTooltip title={text} placement="topLeft">
                    { text }
                </BukkuTooltip>
            </div>
        );
    }
    return '-';
}

function renderBaseAmount(text) {
    const homeCurrencySymbol = store.getState().Auth.companyCurrencySymbol;
    if (text === null || text === undefined)
        return null;

    return <Amount amount={text} currencySymbol={homeCurrencySymbol} />;
}

function renderAmount(text, record) {
    if (text === null || text === undefined)
        return null;

    return <Amount amount={text} currencySymbol={record.currency_symbol} />;
}

function getColClassName(columnType) {
    switch (columnType) {
        case 'type_total':
            return 'report-category-total-col';
        default:
            return null;
    }
}

// also used in StatementColumn helper.js, to retrieve the title
export const getAllStatementColumns = currencyCode => [
    {
        title: <Trans>Date</Trans>,
        dataIndex: 'date',
        key: 'date',
        width: 110,
        onCell: record => ({
            className: getColClassName(record.column_type),
        }),
        render: renderDate,
    },
    {
        title: <Trans>No.</Trans>,
        dataIndex: 'number',
        key: 'number',
        width: 120,
        render: renderNumber,
    },
    {
        title: <Trans>Type</Trans>,
        dataIndex: 'type',
        key: 'type',
        width: 140,
        render: renderType,
    },
    {
        title: <Trans>Reference No.</Trans>,
        dataIndex: 'number2',
        key: 'number2',
        width: 120,
        render: renderRefNo,
    },
    {
        title: <Trans>Description</Trans>,
        dataIndex: 'description',
        key: 'description',
        width: 240,
        render: renderDescription,
    },
    {
        title: <Trans>Title</Trans>,
        dataIndex: 'title',
        key: 'title',
        width: 240,
        render: renderDescription,
    },
    {
        title: (
            <Trans>
                Debit&nbsp;
                {currencyCode}
            </Trans>
        ),
        dataIndex: 'base_debit_amount',
        key: 'base_debit_amount',
        align: 'right',
        width: 170,
        onCell: record => ({
            className: getColClassName(record.column_type),
        }),
        render: renderBaseAmount,
    },
    {
        title: <Trans>Debit</Trans>,
        dataIndex: 'debit_amount',
        key: 'debit_amount',
        align: 'right',
        width: 170,
        onCell: record => ({
            className: getColClassName(record.column_type),
        }),
        render: renderAmount,
    },
    {
        title: (
            <Trans>
                Credit&nbsp;
                {currencyCode}
            </Trans>
        ),
        dataIndex: 'base_credit_amount',
        key: 'base_credit_amount',
        align: 'right',
        width: 170,
        onCell: record => ({
            className: getColClassName(record.column_type),
        }),
        render: renderBaseAmount,
    },
    {
        title: <Trans>Credit</Trans>,
        dataIndex: 'credit_amount',
        key: 'credit_amount',
        align: 'right',
        width: 170,
        onCell: record => ({
            className: getColClassName(record.column_type),
        }),
        render: renderAmount,
    },
    {
        title: (
            <Trans>
                Balance&nbsp;
                {currencyCode}
            </Trans>
        ),
        dataIndex: 'base_balance',
        key: 'base_balance',
        align: 'right',
        width: 170,
        onCell: record => ({
            className: getColClassName(record.column_type),
        }),
        render: renderBaseAmount,
    },
    {
        title: <Trans>Balance</Trans>,
        dataIndex: 'balance',
        key: 'balance',
        align: 'right',
        width: 170,
        onCell: record => ({
            className: getColClassName(record.column_type),
        }),
        render: renderAmount,
    },
];

const getColumns = props => {
    const { companyCurrencyCode } = props;
    return getAllStatementColumns(companyCurrencyCode);
};

export default {
    storageKey: StorageKey.contact_statement,
    required: [
        'date',
        'base_balance',
    ],
    defaulto: [
        'number',
        'description',
        'base_debit_amount',
        'base_credit_amount',
    ],
    getColumns,
};
